import { WebSocketReceiveMessage } from './web-socket-receive-message';
import { HighGuideProductSignal } from '../../../product/dto/product-signal/high-guide-product-signal';

/**
 * The signed-in user recorded a recommendation, on any device - the counterpart to
 * `WebSocketReceiveHighGuideCompanySignalCreated`, which is never fired for the user's own signals.
 *
 * The payload is the bare signal with no author roster: the author is the signed-in user.
 */
export class WebSocketReceiveHighGuideProductSignalCreated extends WebSocketReceiveMessage {
  override payload: HighGuideProductSignal;

  override onDeserialize() {
    super.onDeserialize();
    this.payload = window?.injector?.Deserialize?.instanceOf(HighGuideProductSignal, this.payload);
  }
}
